import React, { useMemo } from "react";
import Shimmer from "../../components/Shimmer";
import classes from "./tileList.module.css";

const TileListShimmer = (props) => {
  const tiles = useMemo(() => {
    return Array.from({ length: 3 })
      .fill(null)
      .map((value, index) => {
        return <Shimmer width={3} height={3} key={`tile-${index}`} />;
      });
  }, []);

  return <div className={classes.root}>{tiles}</div>;
};

export default TileListShimmer;
